// Аудитор банка (deus_auditor_banka, epic).
// А.4.4.1: trigger EOT — +2 Влияния.
// А.4.4.4: ability_order по линии:
//   1-я линия: +1 карта из колоды; возврат 1 юнита в руку владельца (выбор Игрока);
//             +1 extraPlaysNextTurn.
//   2-я линия: Герой владельца +0/2/0 max armor (persistent); союзник +0/0/3 HP (выбор/случайно).

import { addInfluence } from './influence.js';
import { dispatchUnitDied } from './hooks.js';

export const CARD_ID = 'deus_auditor_banka';

// EOT-триггер (как и был в А.4.4.1).
export function auditorEot(state, ownerIdx) {
  addInfluence(state, ownerIdx, 2, 'Аудитор [конец хода]');
}

// Order по 1-й линии.
// targetReturnInstanceId — id юнита для возврата в руку владельца. Если null —
// эффект возврата пропускается (для headless-тестов или если игрок не выбрал).
export function auditorOrderLine1(state, ownerIdx, opts = {}) {
  const p = state.players[ownerIdx];
  // (a) +1 карта из колоды.
  const card = p.drawOne();
  if (card) {
    if (p.hand.length >= 10) {
      p.discard.push(card);
      state.log.add(`📒 Аудитор [${p.name}]: рука переполнена, "${card.name_ru}" сгорает`);
    } else {
      p.hand.push(card);
      state.log.add(`📒 Аудитор [${p.name}]: +1 карта из колоды (в руке: ${p.hand.length})`);
    }
  } else {
    state.log.add(`📒 Аудитор [${p.name}]: колода пуста, карта не пришла`);
  }
  // (b) Возврат 1 юнита в руку — если указан target.
  const targetId = opts.targetReturnInstanceId ?? null;
  if (targetId != null) {
    const target = findUnitByInstanceId(state, targetId);
    if (target && target.line !== null) {
      const owner = state.players[target.ownerId];
      const wasOnFieldOf = state.players[0].field[target.line]?.[target.slot] === target ? 0
                          : state.players[1].field[target.line]?.[target.slot] === target ? 1 : null;
      if (wasOnFieldOf != null) {
        state.players[wasOnFieldOf].field[target.line][target.slot] = null;
      }
      target.line = null;
      target.slot = null;
      // Сбросить мутации
      target.current.atk = target.base.atk;
      target.current.armor = target.base.armor;
      target.current.hp = target.base.hp;
      target.persistentArmor = 0;
      target.persistentMaxArmor = 0;
      target.tempArmorBands = [];
      target.directorAuraApplied = { atk: 0, armor: 0, hp: 0 };
      target.placedTurn = null;
      target.revealed = false;
      target.activated = false;
      target.side = 'owner';
      if (target.template?.keywords) target.keywords = [...target.template.keywords];
      // В руку владельцу.
      if (owner.hand.length >= 10) {
        owner.discard.push(target);
        target.alive = false;
        state.log.add(`📒 Аудитор [${p.name}]: рука [${owner.name}] полна, "${target.name_ru}" сгорает`);
      } else {
        owner.hand.push(target);
        state.log.add(`📒 Аудитор [${p.name}]: ${target.name_ru} возвращён в руку [${owner.name}]`);
      }
    }
  }
  // (c) +1 extraPlaysNextTurn.
  p.extraPlaysNextTurn = (p.extraPlaysNextTurn || 0) + 1;
  state.log.add(`📒 Аудитор [${p.name}]: +1 размещение в следующий Ф2 (всего: ${1 + p.extraPlaysNextTurn})`);
}

// Order по 2-й линии.
// targetAllyInstanceId — id союзника для +0/0/3. Если null или не найдено — выбираем случайно
// из союзников (исключая самого Аудитора, если других нет — пропуск).
export function auditorOrderLine2(state, ownerIdx, opts = {}) {
  const p = state.players[ownerIdx];
  // (a) Герой +2 max armor (persistent).
  p.hero.persistentArmor += 2;
  p.hero.persistentMaxArmor += 2;
  p.hero.current.armor += 2;
  state.log.add(`📒 Аудитор [${p.name}]: Герой +0/2/0 (постоянно), броня=${p.hero.armor}`);
  // (b) Союзник +0/0/3.
  const auditorCard = opts.selfCard;
  let target = null;
  if (opts.targetAllyInstanceId != null) {
    target = p.unitsOnField().find(u => u.instanceId === opts.targetAllyInstanceId);
    if (target === auditorCard) target = null;
  }
  if (!target) {
    const candidates = p.unitsOnField().filter(u => u !== auditorCard);
    if (candidates.length > 0) {
      target = candidates[state.rng.int(candidates.length)];
    }
  }
  if (target) {
    target.current.hp += 3;
    state.log.add(`📒 Аудитор [${p.name}]: ${target.name_ru} +0/0/3 (HP=${target.hp})`);
  } else {
    state.log.add(`📒 Аудитор [${p.name}]: нет союзников для +0/0/3`);
  }
}

function findUnitByInstanceId(state, id) {
  for (const p of state.players) {
    for (const u of p.unitsOnField()) if (u.instanceId === id) return u;
  }
  return null;
}
